export default __webpack_public_path__ + "static/media/teachings.9e433baa.png";